export default __webpack_public_path__ + "static/media/waffle3.d8cbf1c9.png";